module.exports = __webpack_public_path__ + "6c346d87cec15044e1bead50ffaa527d.MP3";